enum MvEcomShoppingBagTypeEnum {
	cart = 'onlineshoppingcart',
	list = 'onlineshoppinglist'
}

export default MvEcomShoppingBagTypeEnum;
